// extracted by mini-css-extract-plugin
module.exports = {"root":"VukDPWXA","textWrapper":"SMeewXuq","title":"aS6ju7V1","viewPastNotificationsButton":"ElvWy8lw"};